import { FunctionFactory } from 'survey-core';
import { tSurvey } from '../i18n/survey';
import { makeSplashHeader } from './SplashHeader';
import { ScienceFamiliarity } from '../quiz/scienceFamiliarity';

const scienceSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">{scienceSplashIcon}</div>
  <div class="splash-header">
    <h1>{scienceSplashTitle}</h1>
    <div class="quote">
      {scienceQuote}
    </div>
  </div>  
</div>`;

const scienceSplashExpression = {
  name: "scienceQuote",
  expression: "renderScienceQuote({science})",
};

function renderScienceQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ScienceFamiliarity) {
    case ScienceFamiliarity.Very:
      return tSurvey("splash.science.quote.very");
    case ScienceFamiliarity.Somewhat:
      return tSurvey("splash.science.quote.somewhat");
    case ScienceFamiliarity.Attempted:
      return tSurvey("splash.science.quote.attempted");
    case ScienceFamiliarity.NotAtAll:
      return tSurvey("splash.science.quote.notAtAll");
  }
}

FunctionFactory.Instance.register("renderScienceQuote", renderScienceQuote);

function renderScienceSplashIcon(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ScienceFamiliarity) {
    case ScienceFamiliarity.Very:
      return "🧠";
    case ScienceFamiliarity.Somewhat:
      return "📚";
    case ScienceFamiliarity.Attempted:
      return "🔍";
    case ScienceFamiliarity.NotAtAll:
      return "💪";
  }
}
const scienceSplashIconExpression = {
  name: "scienceSplashIcon",
  expression: "renderScienceSplashIcon({science})",
};
FunctionFactory.Instance.register("renderScienceSplashIcon", renderScienceSplashIcon);

const scienceSplashTitleExpression = {
  name: "scienceSplashTitle",
  expression: "renderScienceSplashTitle({science})",
};
function renderScienceSplashTitle(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ScienceFamiliarity) {
    case ScienceFamiliarity.Very:
      return tSurvey("splash.science.title.very");
    case ScienceFamiliarity.Somewhat:
      return tSurvey("splash.science.title.somewhat");
    case ScienceFamiliarity.Attempted:
      return tSurvey("splash.science.title.attempted");
    case ScienceFamiliarity.NotAtAll:
      return tSurvey("splash.science.title.notAtAll");
  }
}

FunctionFactory.Instance.register("renderScienceSplashTitle", renderScienceSplashTitle);


const scienceSplashElement = {
  name: 'science-splash',
  type: 'html',
  html: scienceSplashHtml,
}

const ScienceSplashHeader = makeSplashHeader("splash.headers.science");

export {
  scienceSplashElement,
  scienceSplashExpression,
  scienceSplashIconExpression,
  scienceSplashTitleExpression,
  ScienceSplashHeader,
}